import React, { useEffect, useState } from 'react';
import { BaseUrl } from './BaseUrl';
import { AssetsUrl } from './BaseUrl';

export default function Work_Cafes() {
 const [banner_img, setbanner_img] = useState([]);
   const [baseUrl] = useState(BaseUrl);
   const [assetsUrl] = useState(AssetsUrl);

 useEffect(() => {
  fetch(`${baseUrl}/getBannerById/11`)
      .then((resp) => resp.json())
      .then((result) => { 
        setbanner_img(result.banner_images); 
      })
      .catch((err) => console.error("Error fetching banner images:", err));
}, []);

  return (
    <>
<div className="container-fluid slider_top desktop_show">
          <div className="row">
            {banner_img.map((banner, i) => {
              return (
                <div className="col-lg-4 col-12">
                  <img src={`${assetsUrl}/uploads/${banner}`} alt="" className='bnr_img_30 padding_set' />
                </div>
              )
            })}
          </div>
        </div>

      

      <section className="section-reservation-form padding-bottom-100">
        <div className="container">
        <div class="swin-sc swin-sc-title style-2">

<h3 class="title"><span>WORK CAFES</span></h3>
<p class="cafe-text text_justify">Work cafés have been aligned with new global standards embracing thematic design elements to create out of Workplace area concepts & to enhance overall experience.</p>
  </div>

          <div className="reservation-form  ">
          <div class="d-flex justify-content-center">
                <div class="col-md-8 col-md-offset-2">
                  <h4 class="service-title text-center">What Do Work Cafes Offer:</h4>
                  <p class="cafe-text text-center">Our amenities aim to provide the best employee experience across our cafes and pantry areas</p>
                </div>
              </div>
            <div className="row">
              <div className="col-md-12">
                <div className="box-shadow ">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/Beverage-machine.png" alt="" />
                    <p className="sustain_new">Beverage Vending</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Our beverage machines offer a wide variety of both hot and cold beverages</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-6">
                <div className="box-shadow box-equal">
                  <div className="work_sustain hydration">
                    <img src="./assets/images/icon/filter-water.png" alt="" />
                    <p className="sustain_new ">Hydration Station</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Clean, filtered water available: hot or cold</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/microwave.png" alt="" />
                    <p className="sustain_new">Microwave Oven</p>
                  </div>
                  <div>
                  <p className="sustain_new_para refrigerator">Provided for reheating homecooked meals using microwave-safe containers</p>
                    
                  </div>
                </div>
              </div>

              <div className="col-md-6 ">
                <div className="box-shadow box-equal">
                  <div className="work_sustain">
                    <img src="./assets/images/icon/fridge.png" alt="" />
                    <p className="sustain_new">Refrigerators</p>
                  </div>
                  <div>
                  <p className="sustain_new_para ">Refrigerators (Vegetarian & Non-Vegetarian) to store home cooked food</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="box-shadow box-equal p-2">
                  <div className="work_sustain snackspot">
                    <img src="./assets/images/icon/vending-machine.png" style={{ width: '33px' }} alt="" />
                    <p className="sustain_new">Snack Spot</p>
                  </div>
                  <div>
                    <p className="sustain_new_para">Retail grab-scan-pay-go micro market, installed on all floors</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="swin-sc swin-sc-contact-form light mtl">&nbsp;</div>
          </div>
        </div>
      </section>
    </>
  );
}
